var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelAudio14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.325 4.423c.51-.1.74-.153.74.386v4.91c0 .539-.23.487-.74.386L4.293 8.49H3.37A.476.476 0 0 1 2.906 8V6.529c0-.271.202-.49.463-.49h.924Zm3.028.23a.383.383 0 0 1 .532-.04 3.45 3.45 0 0 1 1.253 2.651c0 1.02-.457 1.986-1.253 2.651a.38.38 0 0 1-.532-.04.36.36 0 0 1 .04-.518c.63-.526.991-1.288.991-2.093s-.361-1.567-.99-2.092a.36.36 0 0 1-.041-.52M8.125 5.855a.383.383 0 0 1 .526-.084c.495.346.792.904.792 1.493a1.83 1.83 0 0 1-.792 1.494.4.4 0 0 1-.22.068.38.38 0 0 1-.306-.153.36.36 0 0 1 .087-.513c.298-.208.476-.543.476-.896s-.178-.687-.476-.895a.36.36 0 0 1-.087-.514"
}))));
export default SvgChannelAudio14;